export const LOAD_PICDATA = 'app/Home/CHANGE_USERNAME/LOAD_PICDATA';
export const LOAD_PICDATA_SUCCESS = 'app/Home/CHANGE_USERNAME/LOAD_PICDATA_SUCCESS';
export const LOAD_PICDATA_ERROR = 'app/Home/CHANGE_USERNAME/LOAD_PICDATA_ERROR';



// WEBPACK FOOTER //
// ./src/containers/HomePage/constants.ts